import { createSelector } from 'reselect';
import { seasonLeadersSelector } from './simple-selectors';

export const seasonLeadersDataSelector = createSelector(
    seasonLeadersSelector,
    // @ts-ignore
    (seasonLeaders) => seasonLeaders.data
);
